export class Cache {
  extent: string; // geojson or wkt formats
  id: number;
  resource_uri: string;
  status = 'pending'; // error | pause | pending | done
  title = '';
  zoom_start = 0;
  zoom_end = 22;
  format_tile = 'png'; // png | jpeg
  info = '0%';
  last_cache: Date = null;
  size = 0;
  disk_size: number;
  proc_count = 1;

  // параметры для tastypie
  object_id: number;
  service_type: string;

  constructor(data?: object) {
    this.setData(data);
  }

  setData(data: object) {
    if (data) {
      Object.assign(this, data);
    }
  }
}
